module.exports = __webpack_public_path__ + "static/img/13.652a1735.png";